import React, { useState } from 'react';
import {
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
  NavLink,
  Container
} from 'reactstrap';

const Navigation = props => {
  const [isOpen, setIsOpen] = useState(false);

  const toggle = () => setIsOpen(!isOpen);

  return (
    <Navbar color='light' light expand='md'>
      <Container>
        <NavbarBrand href='/'>
          <span className='text-primary'>Neo</span>{' '}
          <span className='text-muted'>Jay Andong</span>
        </NavbarBrand>
        <NavbarToggler onClick={toggle} />
        <Collapse isOpen={isOpen} navbar>
          <Nav className='ml-auto' navbar>
            {/* eslint-disable */}
            <NavItem active>
              <NavLink href='/components/'>Home</NavLink>
            </NavItem>
            <NavItem>
              <NavLink href='javascript:void(0)'>Projects</NavLink>
            </NavItem>
            <NavItem>
              <NavLink href='javascript:void(0)'>Skills</NavLink>
            </NavItem>
          </Nav>
        </Collapse>
      </Container>
    </Navbar>
  );
};

export default Navigation;
